import { Outlet } from "react-router-dom";
import { TopBar } from "./TopBar";
import { PlanBanner } from "./PlanBanner";
import { BottomTabs } from "./BottomTabs";
import { SideNav } from "./SideNav";

export function AppShell() {
  return (
    <div className="app-shell">
      <SideNav />
      <TopBar />
      <PlanBanner />
      <main className="main">
        <Outlet />
      </main>
      <BottomTabs />
    </div>
  );
}
